import React from 'react';
import { Space, Tabs, Typography } from 'antd';
import { ApiOutlined, FileOutlined, UserOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { useDispatch, useModel, useSelector } from 'umi';

import CSVLeadSourceImport from './CSV/Index';
import WebhookLeadSourceConfig from './Webhook';
import AddManualLead from './ManualLead';
import { LEAD_SOURCE_TYPE_CSV, LEAD_SOURCE_TYPE_WEBHOOK } from './constants';
import { hasAccess } from '@/utils/access';
import PERMISSIONS from '@/constants/permissions';
import * as LeadSelectors from '@/selectors/leadSelectors';
import { F, INTL_ACTION, INTL_ENTITY } from '@/utils/intl';

const {Text} = Typography;

const LeadSourceSwitcher = ({onTabChange}) => {
  const dispatch = useDispatch();
  const {initialState, setInitialState} = useModel('@@initialState');
  const addLeadDrawer = useSelector(LeadSelectors.selectAddLeadDrawer)
  const handleSourceChange = (tabKey: string) => {
    const tab = filteredTabs.find((tab) => tab.key === tabKey);
    onTabChange(tab)
    dispatch({
      type: 'leadSources/saveLeadSourceDetail',
      payload: {},
    });
  };
  const {leadSourceList} = useSelector((state: DefaultRootState) => ({
    leadSourceList: state.journey.list,
  }));
  const csvSourceCount = leadSourceList.filter(
    (source) => source.type === LEAD_SOURCE_TYPE_CSV,
  )?.length;
  const webhookSourceCount = leadSourceList.filter(
    (source) => source.type === LEAD_SOURCE_TYPE_WEBHOOK,
  )?.length;


  const tabs = [{
    key: "manual",
    label: <Space>
      <UserOutlined/>
      <F id={"components.leadSourceSwitcher.manual"} defaultMessage={"Manual"}/>
    </Space>,
    children: <AddManualLead/>,
    drawerWidth: 800,
  }, {
    key: "csvFile",
    label: <Space>
      <FileOutlined/>
      <F id={"components.leadSourceSwitcher.csvFile"} defaultMessage={"CSV File"}/>
      {`( ${csvSourceCount} )`}
    </Space>,
    children: <CSVLeadSourceImport/>,
    drawerWidth: 800,
  }, {
    key: "webhook",
    label: <Space>
      <ApiOutlined/>
      <F id={"components.leadSourceSwitcher.webhook"} defaultMessage={"Webhook"}/>
      {`( ${webhookSourceCount} )`}

    </Space>,
    children: <WebhookLeadSourceConfig/>,
    drawerWidth: 800,
  }, {
    key: "Carat",
    label: <Space>
      <F id={"components.leadSourceSwitcher.carat"} defaultMessage={"Carat Planer"}/>
    </Space>,
    disabled: true
  },
  //   {
  //   key: "QR",
  //   label: <Space>
  //     <F id={"components.leadSourceSwitcher.qr"} defaultMessage={"QR Code"}/>
  //   </Space>,
  //   disabled: true
  // }, {
  //   key: "API",
  //   label: <Space>
  //     <F id={"components.leadSourceSwitcher.api"} defaultMessage={"API"}/>
  //   </Space>,
  //   disabled: true
  // },
    {
    key: "Outlook",
    label: <Space>
      <F id={"components.leadSourceSwitcher.outlook"} defaultMessage={"Outlook"}/>
    </Space>,
    disabled: true
  },
  //   {
  //   key: "Journeys",
  //   label: <Space>
  //     <F id={"components.leadSourceSwitcher.journeys"} defaultMessage={"Journeys"}/>
  //   </Space>,
  //   disabled: true
  // }
  ]
  const filteredTabs = tabs.filter(tab => {
    if (Array.isArray(addLeadDrawer?.filterTabs) && !addLeadDrawer.filterTabs.includes(tab.key)) {
      return false
    }
    if (tab.key === 'manual') {
      return true;
    }
    return hasAccess(
      initialState.currentUser,
      [
        PERMISSIONS.LeadSource.VIEW,
        PERMISSIONS.LeadSource.CREATE,
        PERMISSIONS.LeadSource.EDIT,
        PERMISSIONS.LeadSource.DELETE,
      ],
      {asterisk: true},
    );

  });
  return (
    <>
      {filteredTabs.length > 1 && <Text style={{fontSize: '16px', marginBottom: 16, display: "block", fontWeight: '500'}}>
        <F entity={INTL_ENTITY.LEAD_SOURCE} action={INTL_ACTION.SELECT}/>{' '}
      </Text>}
      {filteredTabs.length === 1 ? filteredTabs[0].children : <Tabs
        onChange={handleSourceChange}
        className={classNames('ant-tab-type-button')}
        defaultActiveKey="manual"
        items={filteredTabs}
      />}
    </>
  );
};

export default LeadSourceSwitcher;
